import { render, staticRenderFns } from "./TravelQuoteUpdateStatus.vue?vue&type=template&id=513a2bb7&"
import script from "./TravelQuoteUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./TravelQuoteUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./TravelQuoteUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelQuoteUpdateStatus.vue"
export default component.exports